import { DataBean } from "../DataBean";

export class AccountantCycle extends DataBean {


    public async getAccountantCyclesUpto(lastDate: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getAccountantCyclesUpto_java.util.Date", [lastDate]);
    }
    public async getAccountantCyclesWithAdjustmentsUpto(lastDate: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getAccountantCyclesWithAdjustmentsUpto_java.util.Date", [lastDate]);
    }
    public async closeAccountantPeriod(year: any, month: any, idEmployee: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "boolean_closeAccountantPeriod_Number_Number_Number", [year, month, idEmployee]);
    }
    public async closeAccountantPeriodThread(year: any, month: any, idEmployee: any): Promise<any> {
        return this.getCustomService("CacheOptions", "boolean_closeAccountantPeriodThread_Number_Number_Number", [year, month, idEmployee]);
    }

    public async deleteLeftBatch(idAccountantCycle: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "boolean_deleteLeftBatch_Number", [idAccountantCycle]);
    }

}